import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../config';

interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * Waits for i18next to finish loading translations via HTTP before rendering
 * the app. With HttpBackend, initialization is async — rendering before it's
 * complete would show translation keys instead of translated strings.
 */
export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [ready, setReady] = React.useState(i18n.isInitialized);

  React.useEffect(() => {
    if (i18n.isInitialized) return;

    const onInit = () => setReady(true);
    i18n.on('initialized', onInit);
    return () => { i18n.off('initialized', onInit); };
  }, []);

  if (!ready) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#fff',
      }}>
        <div style={{
          width: 36,
          height: 36,
          border: '3px solid #e0e0e0',
          borderTop: '3px solid #1976d2',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
